import { render, staticRenderFns } from "./FarmerDetailLand.vue?vue&type=template&id=eb676c0a"
import script from "./FarmerDetailLand.vue?vue&type=script&lang=js"
export * from "./FarmerDetailLand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports